/**
 * Checks if the current device is a mobile device.
 *
 * @returns {boolean} True if the device is a mobile device, false otherwise.
 */
export const isMobileDevice: boolean =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  )

/**
 * Scrolls the window to the top of the page with a smooth animation.
 */
export const scrollToTop = () => {
  window.scrollTo({ behavior: 'smooth', top: 0 })
}

/**
 * Finds the matching variation based on selected options.
 *
 * @param {Array} variations - The array of variations to search through.
 * @param {Object} selectedOptions - The selected options to match against.
 * @returns {Object|undefined} - The matching variation object, or undefined if no match is found.
 */
export function findMatchingVariation(variations, selectedOptions) {
  return variations.find((variation) =>
    Object.keys(variation.terms).every(
      (term) => selectedOptions[term] === variation.terms[term],
    ),
  )
}

/**
 * Finds sizes for a given color in an array of variations.
 *
 * @param {Array} variations - The array of variations.
 * @param {string} selectedColor - The selected color.
 * @returns {Array} - An array of sizes for the selected color.
 */
export function findSizesForColor(variations, selectedColor) {
  const variationsForColor = variations.filter(
    (variation) => variation.terms.pa_color === selectedColor,
  )
  return variationsForColor.map((variation) => variation.terms.pa_size)
}

export const createURLParams = <T extends Record<string, unknown>>(
  request: T,
): string => {
  if (!request) return

  const params = new URLSearchParams()

  Object.entries(request).forEach(([key, value]) => {
    if (value) {
      params.set(key, value.toString())
    }
  })

  return params.toString()
}

export function generateUuidList(length: number): Array<string> {
  return Array.from({ length }, () => crypto.randomUUID())
}

export * from './parse-html'
